  <div  class="modal fade d-block feed-modal-container" 
    [config]="{ show: true,backdrop: 'relative' }" 
    id="feedModal" 
    *ngIf="feedDetailModal==true && feedObject!=undefined && feedObject!=null" 
    (onHidden)="onHidden()" 
    bsModal 
    #autoShownModal="bs-modal">
      <span *ngIf="feedObject?.media_list.length==0" 
        data-dismiss="modal" 
        class="cursor-pointer mt-2 text-white float-left mr-1 position-absolute back-btn-container" 
        (click)="hideModal()">
          <img src="assets/themes/icons/gallery-back-icon.svg" alt="back icon" class="mr-2 back-icon" />
      </span>

      <div class="custom-theme-modal modal-dialog modal-dialog-centered popup mt-3 mb-3" 
        [ngClass]="{'modal-xl':feedObject?.media_list.length>0,'modal-md':feedObject?.media_list.length==0 }">
        <div  class="modal-content feed-details-modal-content feed-detail-modal bg-transparent">
          <span  *ngIf="feedObject?.media_list.length!=0"
              data-dismiss="modal" 
              class="cursor-pointer mt-2 text-white float-left mr-1 position-absolute back-media-btn-container" 
              (click)="hideModal()" style="">
              <img src="assets/themes/icons/gallery-back-icon.svg" class="back-icon" alt="back icon" />
          </span>

          <app-web-feed-detail
            (feedSpecialty)="getFeedTagDetails($event)"
            [feedId]="feedId"
            [isModal]="true"
            [mediaIdx]="mediaIdx"
            [ecId]="ecId"
            [isPostedEvent]="isPostedEvent"
            (resetFeedDetailModal)="hideModal()"
            (emitRepostData)="emitRepostData()">
          </app-web-feed-detail>

        </div>

      </div>
    </div>
  
  <!-- like list popup start**************************** -->
  <!-- <app-product-like *ngIf="showLikeListModal==true" (resetLikeModalList) = resetLikeModalList($event) (resetLike) = resetLike($event) [likeObj]=likeObj></app-product-like>  -->
  <!-- like list popup end ***************************** -->
  
  
  <!-- Bookmark start -->
  <!-- <app-product-bookmark *ngIf="is_bookmark==true" (resetBookmark) = resetBookmark($event) [bookmarkObj]=bookmarkObj></app-product-bookmark> -->
  <!-- Bookmark end -->